import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';

import type { TWithdrawal } from '../../store/types';

export const convertWithdrawalsToTable = (items: TWithdrawal[]): TWithdrawal[] => {
  const payments: TWithdrawal[] = items.map((item) => ({
    ...item,
    created: dayjsCustom(item.created).format('DD.MM.YYYY / HH:mm'),
    // updated: dayjsCustom(item.updated).format('DD.MM.YYYY / HH:mm'),
  }));

  return payments;
};
